// Free-text portion only. The backend appends " - <time of day>" after this
// (worst case ~40 chars: " - morning, afternoon, evening, anytime"), so the
// full stored field stays within a ~90-char budget.
export const MAX_BEVERAGE_DESCRIPTION_LENGTH = 60;
